module.exports = __webpack_public_path__ + "img/live03.c51fcdfb.png";